import React from 'react';
import BaseCard from '../common/layout/BaseCard';
import Avatar from '../common/display/Avatar';
import { Community } from './types';
import { captureCustomEvent } from '../../utils/posthogUtils';

interface CommunityAboutSectionProps {
  community: Community;
}

export const CommunityAboutSection: React.FC<CommunityAboutSectionProps> = ({ community }) => {
  if (!community.description && !community.workspace) {
    return null; // Don't render if there's nothing to show
  }

  const handleWorkspaceClick = () => {
    captureCustomEvent('community_workspace_clicked', {
      eventProperties: {
        community_id: community.id,
        community_name: community.name,
        workspace_id: community.workspace?.workspace_id,
        workspace_name: community.workspace?.workspace_name
      }
    });
  };

  return (
    <BaseCard>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">
        About this community
      </h2>
      {community.description && (
        <p className="text-gray-600 whitespace-pre-wrap mb-4 break-words">
          {community.description}
        </p>
      )}
      {community.workspace && (
        <a 
          href={`/workspace/${community.workspace.workspace_id}`} 
          className="flex items-center gap-2 mb-4 group"
          onClick={handleWorkspaceClick}
        >
          <Avatar
            firstName={community.workspace.workspace_name}
            profileImageUrl={community.workspace.logo_url || undefined}
            size="tiny"
          />
          <span className="text-sm text-gray-600">
            by <span className="font-medium text-gray-900 group-hover:text-primary-base">{community.workspace.workspace_name}</span>
          </span>
        </a>
      )}
    </BaseCard>
  );
}; 